module.exports = __webpack_public_path__ + "static/BlogListing-2-060e222ac6d0f5ad88e4db9604c8ab1b.png";